import { render } from "./ContentEmpty.vue?vue&type=template&id=88d85d60&lang=pug"
import script from "./ContentEmpty.vue?vue&type=script&lang=js"
export * from "./ContentEmpty.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__